import { Input } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Functions } from "@hub/common/Functions";
import { ModelError } from "@hub/models/ModelError";
import { Subscription } from 'rxjs';


export abstract class BaseErrorForm {
	constructor() {
	}

	isInvalid: boolean;
	isDisabled: boolean;

	controlSub: Subscription;
	private _control;
	@Input() set control(c: FormControl) {
		this._control = c;
		if (this.controlSub) {
			this.controlSub.unsubscribe();
		}
		this.controlSub = c.statusChanges.subscribe(x => {
			this.isDisabled = this._control.disabled;
			if (this.isInvalid)
				this.isInvalid = false;
		});
	}
	get control() {
		return this._control;
	}
	@Input() messages: { [key: string]: string };
	@Input('key') public key: string;
	private _errors: any;
	@Input('errors')
	public set errors(errors: ModelError[]) {
		this._errors = errors;
		if (!!errors && Array.isArray(errors) && errors.length > 0) {
			if (!!this.key && errors.some(x => x.Key.toLowerCase() === this.key.toLowerCase())) {
				let error = errors.find(x => x.Key.toLowerCase() === this.key.toLowerCase());
				if (error.Messages.length > 0) {
					this.isInvalid = true;
				}
			}
		} else {
			this.isInvalid = false;
		}
	}
	public get errors() {
		return this._errors;
	}

	isFieldInvalid() {
		if (this.isInvalid || this.control && Functions.isFieldInvalid(this.control)) {
			return true;
		}

		return false;
	}
}
